/**
 * 纯浏览器：按 /user/info 的 runtimeLane 在现网 / 灰度域之间整页跳转。
 * App WebView 由 Native 改 webviewOrigin，调用方应对 isAppUser 跳过。
 */

const PROD_HOST = 'mobileapp.ux.com';
const GRAY_HOST = 'mobileapp2.ux.com';

export type RuntimeLane = 'prod' | 'gray';

export function normalizeRuntimeLane(raw: unknown): RuntimeLane {
  if (raw === 'gray' || raw === 'GRAY') return 'gray';
  if (raw === true || raw === 1 || raw === '1') return 'gray';
  if (typeof raw === 'object' && raw != null && !Array.isArray(raw)) {
    const obj = raw as Record<string, unknown>;
    if ('runtimeLane' in obj) return normalizeRuntimeLane(obj.runtimeLane);
    if ('grayEnv' in obj) return normalizeRuntimeLane(obj.grayEnv);
  }
  return 'prod';
}

/**
 * 若当前 host 与 lane 不一致则 `location.replace` 到目标域（保留 path/query/hash）。
 * @returns 是否已发起跳转（调用方应中止后续逻辑）
 */
export function redirectForRuntimeLane(rawLane: unknown): boolean {
  if (typeof window === 'undefined') return false;
  const lane = normalizeRuntimeLane(rawLane);
  const { hostname, protocol, pathname, search, hash } = window.location;
  if (hostname !== PROD_HOST && hostname !== GRAY_HOST) return false;

  const nextHost = lane === 'gray' ? GRAY_HOST : PROD_HOST;
  if (nextHost === hostname) return false;

  window.location.replace(`${protocol}//${nextHost}${pathname}${search}${hash}`);
  return true;
}
